<script setup lang="ts">
import { pageTitle } from '@partner-spa-vue/stores/LayoutStore';
import PartnerEarningsHistory from './PartnerEarningsHistory.vue';
import DeliveryteamEarningsHistory from './DeliveryteamEarningsHistory.vue';

pageTitle.value = 'History';
</script>

<template>
    <div class="max-w-3xl mx-auto space-y-4">
        <PartnerEarningsHistory partner-type="marketing" />
        <DeliveryteamEarningsHistory />
    </div>
</template>
